"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _constants = require("@seedlang/constants");
var _diff = require("diff");
var _src = require("@seedlang/utils/src");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var WordTranslateCardWrapper = function WordTranslateCardWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _this.hideOnboardingPopups = function () {
        if (!_state.DeckUI.user.wasUiElementSeen('reviewIconOnboarding')) {
          _state.AppUI.designateUiElementAsSeen('reviewIconOnboarding');
        }
        if (!_state.DeckUI.user.wasUiElementSeen('toggleKeyboardMicrophoneOnboarding')) {
          _state.AppUI.designateUiElementAsSeen('toggleKeyboardMicrophoneOnboarding');
        }
      };
      _this.showOnboarding = function (slug) {
        var _this$props$card, _this$props$card2;
        return !((_this$props$card = _this.props.card) !== null && _this$props$card !== void 0 && (_this$props$card = _this$props$card.cardState) !== null && _this$props$card !== void 0 && _this$props$card.onboardingTipSeen) || ((_this$props$card2 = _this.props.card) === null || _this$props$card2 === void 0 || (_this$props$card2 = _this$props$card2.cardState) === null || _this$props$card2 === void 0 ? void 0 : _this$props$card2.lastOnboardingTipSeen) === slug;
      };
      _this.shouldFloatHints = function (inputHeight, hintHeight) {
        return !_this.showUserInput && inputHeight > 0 && inputHeight + 2 * hintHeight <= _this.sectionHeight - 20;
      };
      _this.afterVideoPlayback = function () {
        _state.DeckUI.playUserInputAfterRevealVideo(_this.props.card, _this.props.cardState);
      };
      _this.onHelpButtonClicked = function () {
        if (!_this.showHelpButton) {
          return;
        }
        _this.helpClickedCount = !_this.hasSentenceHint ? Math.min(_this.helpClickedCount + 1, 2) : _this.helpClickedCount === 1 ? 2 : 1;
        _state.DeckUI.warning = '';
      };
      _this.onTextInputChange = function (val) {
        if (_state.DeckUI.user.evaluateVocabOnKeystroke) {
          _state.DeckUI.onWordInputChangeAndEvaluate(_this.props.card, _this.props.cardState, _this.props.userCard, val);
        } else {
          _state.DeckUI.onWordInputChange(_this.props.cardState, val);
        }
      };
      _this.setShowHelp = function (showHelp) {
        _this.showHelp = showHelp;
        if (showHelp) {
          _this.onShowHelp();
        } else {
          _this.onLeaveHelp();
        }
      };
      _this.onLeaveHelp = function () {
        if (_this.props.cardState && (0, _utils.isPresent)(_this.props.cardState)) {
          _this.props.cardState.resetWithinCard();
        }
        if (_this.props.card.sentence && _this.props.card.sentence.state) {
          _this.props.card.sentence.state.reset();
        }
      };
      _this.onShowHelp = function () {
        _state.DeckUI.designateUiElementAsSeen('helpMe');
        if (_this.props.cardState) {
          _this.props.cardState.set('showHelp', true);
          _this.props.cardState.set('helpWasShown', true);
        }
      };
      _this.textToDiffArray = function (text) {
        var _this$props$card3;
        if ((0, _src.isBlank)((_this$props$card3 = _this.props.card) === null || _this$props$card3 === void 0 ? void 0 : _this$props$card3.word)) {
          return;
        }
        var articlesList = (0, _lodash.values)(_constants.Constants.SINGULAR_ARTICLES[_this.props.card.word.languageId]).concat((0, _lodash.values)(_constants.Constants.PLURAL_ARTICLES[_this.props.card.word.languageId]));
        return (0, _lodash.flatten)(text.split(/(?=\s)/).map(function (item) {
          return articlesList.includes(item) ? item : item.split('');
        }));
      };
      _this.diff = function (displayedText, ref) {
        if ((0, _src.isBlank)(displayedText) && (0, _src.isBlank)(ref)) {
          return;
        }
        if ((0, _src.isBlank)(ref)) {
          return displayedText;
        }
        var diff = (0, _diff.diffArrays)(_this.textToDiffArray(ref), _this.textToDiffArray(displayedText), {
          maxEditLength: 3,
          ignoreCase: !_state.DeckUI.user.enforceCasing
        });
        if ((0, _src.isBlank)(diff)) {
          return displayedText;
        }
        return diff.map(function (part, index) {
          if (!part.removed) {
            return /*#__PURE__*/_react["default"].createElement("span", {
              key: index,
              className: part.added ? 'diff' : 'no-diff'
            }, part.value.join(''));
          }
        });
      };
      _state.DeckUI.enrichWord(_this.props.card);
      _this.previousShowUserInput = _this.showUserInput;
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "helpClickedCount",
      get: function get() {
        return this.props.cardState.helpClickedCount;
      },
      set: function set(value) {
        this.props.cardState.set('helpClickedCount', value);
      }
    }, {
      key: "showHelp",
      get: function get() {
        return this.props.cardState.showHelp;
      },
      set: function set(value) {
        this.props.cardState.set('showHelp', value);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var showUserInputChangedToTrue = !this.previousShowUserInput && this.showUserInput;
        this.previousShowUserInput = this.showUserInput;
        if (showUserInputChangedToTrue) {
          if ((0, _utils.isPresent)(this.props.cardState.textEntry)) {
            this.props.cardState.set('textEntry', '');
          }
          _state.DeckUI.warning = '';
        }
      }
    }, {
      key: "message",
      get: function get() {
        if (this.props.card.cardTypeSlug === 'number_translate') {
          return "Write this number in ".concat(_constants.Languages[this.props.card.word.languageId]);
        }
        if (this.props.card.word && this.props.card.word.wordType) {
          return "Translate this ".concat(this.props.card.word.wordType.formattedName);
        }
        return 'Translate this word';
      }
    }, {
      key: "icons",
      get: function get() {
        var ary = [];
        if (!this.props.cardState.revealed && !_state.AppUI.user.blockMediaAccess) {
          ary.push('toggleMicrophone');
        }
        if ((0, _utils.isPresent)(this.props.card.grammarTip)) {
          ary.push('grammarTip');
        }
        if (_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('reviewDetails');
        }
        if (!_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('toggleReview');
        }
        if (this.props.cardState.revealed) {
          ary.push('cardComments');
        }
        if (this.props.cardState.revealed && _state.DeckUI.showDeckGrammarIcon) {
          ary.push('deckGrammar');
        }
        if (_state.DeckUI.reviewDeck && (this.props.cardState.revealed || this.props.card.showNoteBeforeReveal)) {
          ary.push('cardNote');
        }
        if (this.props.cardState.revealed) {
          ary.push('vocabCard');
        }
        return ary;
      }
    }, {
      key: "showHelpButton",
      get: function get() {
        var _this$props$card$word;
        if (((_this$props$card$word = this.props.card.word) === null || _this$props$card$word === void 0 ? void 0 : _this$props$card$word.targetText.length) < 3) {
          return this.helpClickedCount < 1;
        }
        if (!this.hasSentenceHint && this.helpClickedCount >= 2) {
          return false;
        }
        return Boolean(this.props.card.word);
      }
    }, {
      key: "numSections",
      get: function get() {
        return this.props.cardState.revealed && this.props.card.hasTargetVideoClip ? 3 : 2;
      }
    }, {
      key: "sectionHeight",
      get: function get() {
        var height;
        height = _state.DeckUI.layout.heightForCardSections(this.numSections, 0, false);
        if (_state.DeckUI.layout.isNative && _state.DeckUI.layout.keyboardVisible) {
          var padding = _state.DeckUI.layout.isAndroid && !_state.DeckUI.layout.hasNativeMenuBar ? 45 : 25;
          height = height + _state.DeckUI.layout.buttonHeight - padding;
        }
        if (this.showUserInput) {
          var userInputHeight = _state.DeckUI.layout.userInputHeight / this.numSections;
          return height - userInputHeight;
        } else {
          return height;
        }
      }
    }, {
      key: "vocabCardIncorrect",
      get: function get() {
        return this.props.cardState.revealed && !this.props.userCard.correct;
      }
    }, {
      key: "arrowBoxes",
      get: function get() {
        return {
          toggleKeyboardMicrophoneOnboarding: !this.props.cardState.revealed,
          reviewIconOnboarding: !_state.DeckUI.reviewDeck && this.props.cardState.revealed,
          spacedRepetitionOnboarding: _state.DeckUI.reviewDeck && this.props.cardState.revealed,
          helpMeOnboarding: !this.props.cardState.revealed && !_state.DeckUI.layout.isNative,
          noteOnboarding: _state.DeckUI.reviewDeck && this.props.cardState.revealed,
          commentOnboarding: this.props.cardState.revealed,
          vocabCardOnboarding: !_state.DeckUI.reviewDeck && this.props.cardState.revealed,
          translateVocab: this.showUserInput && !this.props.cardState.revealed && !(_state.DeckUI.userInputStore.isRecording || _state.DeckUI.userInputStore.hasFinishedRecording)
        };
      }
    }, {
      key: "possibleArrowBoxes",
      get: function get() {
        return (0, _lodash.keys)(this.arrowBoxes);
      }
    }, {
      key: "currentArrowBox",
      get: function get() {
        var _this2 = this;
        var arrowBox;
        (0, _lodash.each)(this.possibleArrowBoxes, function (slug) {
          if (_this2.showOnboarding(slug) && _this2.arrowBoxes[slug] && !_state.DeckUI.user.wasUiElementSeen(slug) && _state.AppUI.userCreatedInLastWeek && !arrowBox) {
            arrowBox = slug;
          }
        });
        return arrowBox;
      }
    }, {
      key: "answerFeedback",
      get: function get() {
        if (this.showUserInput || !this.props.cardState.revealed) return null;
        return (0, _utils.cardAnswerFeedback)(this.props.userCard.correct, this.props.cardState.textEntry);
      }
    }, {
      key: "showUserInput",
      get: function get() {
        return _state.DeckUI.user.vocabCardAudio;
      }
    }, {
      key: "maskWord",
      value: function maskWord(text) {
        var characters = Array.from(text);
        var visibleCount = Math.min(this.helpClickedCount, 2);
        return [{
          text: characters.slice(0, visibleCount).join(''),
          masked: false
        }, {
          text: characters.slice(visibleCount).join(''),
          masked: true
        }].filter(function (part) {
          return part.text;
        });
      }
    }, {
      key: "hasSentenceHint",
      get: function get() {
        var _this$props$card$word2;
        return Boolean(_state.DeckUI.showVocabExampleSentences && this.props.card.vocabWordTranslateCard && ((_this$props$card$word2 = this.props.card.word) === null || _this$props$card$word2 === void 0 || (_this$props$card$word2 = _this$props$card$word2.cardExampleSentence) === null || _this$props$card$word2 === void 0 ? void 0 : _this$props$card$word2.some(function (part) {
          return part.underline;
        })));
      }
    }, {
      key: "sentenceHintParts",
      get: function get() {
        var _this3 = this;
        if (!this.hasSentenceHint || this.helpClickedCount !== 1) {
          return;
        }
        var word = this.props.card.word;
        var parts = word === null || word === void 0 ? void 0 : word.cardExampleSentence;
        var result = [];
        var precedingText = '';
        parts.forEach(function (part) {
          if (!part.underline) {
            precedingText += part.text;
            return;
          }
          var article = word.languageId === 'DE' && word.isNoun && part.text === word.targetText && /(?<!(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0345\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088F\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5C\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDC-\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7DC\uA7F1-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD40-\uDD59\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDD40-\uDD65\uDD6F-\uDD85\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC7\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDED0-\uDEE3\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0\uDFF0-\uDFF9]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDDB0-\uDDDB\uDDE0-\uDDE9\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDF50-\uDF59\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D\uDD30-\uDD39]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDD70-\uDD79\uDE40-\uDE96\uDEA0-\uDEB8\uDEBB-\uDED3\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3\uDFF2-\uDFF6]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD833[\uDCF0-\uDCF9]|\uD834[\uDEC0-\uDED3\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDCD0-\uDCEB\uDCF0-\uDCF9\uDDD0-\uDDED\uDDF0-\uDDFA\uDEC0-\uDEDE\uDEE0-\uDEE2\uDEE4\uDEE5\uDEE7-\uDEED\uDEF0-\uDEF4\uDEFE\uDEFF\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]))(d)(er|ie|a[s\u017F])([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+)$/i.exec(precedingText);
          if (article && "".concat(article[1]).concat(article[2]).toLowerCase() === word.definiteArticle) {
            result.push({
              text: precedingText.slice(0, article.index) + article[1]
            });
            result.push({
              text: article[2],
              masked: true
            });
            result.push({
              text: article[3]
            });
          } else if (precedingText) {
            result.push({
              text: precedingText
            });
          }
          precedingText = '';
          result.push.apply(result, _toConsumableArray(_this3.maskWord(part.text)));
        });
        if (precedingText) result.push({
          text: precedingText
        });
        return result;
      }
    }, {
      key: "hintParts",
      get: function get() {
        if (!this.helpClickedCount || !this.props.card.word) {
          return [];
        }
        if (this.sentenceHintParts) return this.sentenceHintParts;
        return [{
          text: this.letterHint.replace(/ /g, "\u2003").replace(/_(?=_)/g, '_ ')
        }];
      }
    }, {
      key: "letterHint",
      get: function get() {
        var _this4 = this;
        if (this.helpClickedCount === 0) {
          return;
        }
        if (!this.props.card.word) {
          return;
        }
        var str = '';
        if (this.props.card.word.isNoun && (0, _utils.isPresent)(this.props.card.word.gender) && !this.props.card.word.useParenthesesOnGender && !this.props.card.word.articleIsHidden) {
          if (this.props.card.word.languageId === 'DE') {
            str = 'd__ ';
          } else if (this.props.card.word.languageId === 'FR') {
            if (this.props.card.word.plural) {
              str = 'l__ ';
            } else if (this.props.card.word.articleHasApostrophe || _constants.Constants.LETTERS_THAT_TAKE_APOSTROPHE_IN_FR.includes(this.props.card.word.targetText[0])) {
              if (this.helpClickedCount === 1) {
                str = 'l_';
              } else if (this.helpClickedCount === 2) {
                str = 'l\'';
              }
            } else {
              str = 'l_ ';
            }
          } else if (this.props.card.word.languageId === 'ES') {
            if (this.props.card.word.plural) {
              str = 'l__ ';
            } else {
              str = '__ '; // el / la
            }
          }
        }
        var targetCharactersToReveal = [];
        if (this.props.card.word.targetText.length > 1) {
          targetCharactersToReveal.push(0);
        }
        if (this.props.card.word.languageId === 'ES' && this.props.card.word.isNoun && this.props.card.word.targetText.length > 3) {
          targetCharactersToReveal.push(this.props.card.word.targetText.length - 2); // penultimate char
        } else if (this.props.card.word.targetText.length > 3) {
          targetCharactersToReveal.push(this.props.card.word.targetText.length - 1); // last char
        }
        var targetHint = '_'.repeat(this.props.card.word.targetText.length);
        // add spaces to targetCharactersToReveal
        (0, _lodash.each)(this.props.card.word.targetText.split(''), function (_char, index) {
          if (_char === ' ' || _char === '.') {
            targetCharactersToReveal.push(index);
            targetCharactersToReveal.push(index + 1);
          }
        });
        if (this.helpClickedCount > 1) {
          (0, _lodash.each)(targetHint, function (_char2, index) {
            if (index % 3 === 1 && !targetCharactersToReveal.includes(index)) {
              targetCharactersToReveal.push(index);
            }
          });
        }
        // reveal characters
        targetCharactersToReveal.forEach(function (charIndex) {
          targetHint = targetHint.slice(0, charIndex) + _this4.props.card.word.targetText[charIndex] + targetHint.slice(charIndex + 1, targetHint.length);
        });
        str = str + targetHint;
        return str;
      }
    }, {
      key: "hint",
      get: function get() {
        return this.hintParts.map(function (part) {
          return part.text;
        }).join('');
      }
    }, {
      key: "sentenceHint",
      get: function get() {
        var _this$sentenceHintPar;
        return (_this$sentenceHintPar = this.sentenceHintParts) === null || _this$sentenceHintPar === void 0 ? void 0 : _this$sentenceHintPar.map(function (part) {
          return part.text;
        }).join('');
      }
    }, {
      key: "correctAnswer",
      get: function get() {
        var _this$props$card$word3, _this$props$card$word4, _this$props$card$word5;
        return (_this$props$card$word3 = this.props.card.word) !== null && _this$props$card$word3 !== void 0 && _this$props$card$word3.hideDefiniteArticle ? (_this$props$card$word4 = this.props.card.word) === null || _this$props$card$word4 === void 0 ? void 0 : _this$props$card$word4.targetText : (_this$props$card$word5 = this.props.card.word) === null || _this$props$card$word5 === void 0 ? void 0 : _this$props$card$word5.targetTextWithDefiniteArticle;
      }
    }, {
      key: "correctAnswerWithDiff",
      get: function get() {
        var _this$props$card$word6, _this$props$card$word7;
        if ((_this$props$card$word6 = this.props.card.word) !== null && _this$props$card$word6 !== void 0 && _this$props$card$word6.hideDefiniteArticle) {
          this.diff(this.props.card.word.targetText, this.props.cardState.textEntry);
        }
        return this.diff((_this$props$card$word7 = this.props.card.word) === null || _this$props$card$word7 === void 0 ? void 0 : _this$props$card$word7.targetTextWithDefiniteArticle, this.props.cardState.textEntry);
      }
    }, {
      key: "wrongAnswerWithDiff",
      get: function get() {
        var _this$props$card$word8, _this$props$card$word9;
        if ((_this$props$card$word8 = this.props.card.word) !== null && _this$props$card$word8 !== void 0 && _this$props$card$word8.hideDefiniteArticle) {
          this.diff(this.props.cardState.textEntry, this.props.card.word.targetText);
        }
        return this.diff(this.props.cardState.textEntry, (_this$props$card$word9 = this.props.card.word) === null || _this$props$card$word9 === void 0 ? void 0 : _this$props$card$word9.targetTextWithDefiniteArticle);
      }
    }, {
      key: "showExpandedTarget",
      get: function get() {
        return this.props.cardState.revealed;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          numSections: this.numSections,
          sectionHeight: this.sectionHeight,
          vocabCardIncorrect: this.vocabCardIncorrect,
          possibleArrowBoxes: this.possibleArrowBoxes,
          currentArrowBox: this.currentArrowBox,
          answerFeedback: this.answerFeedback,
          showUserInput: this.showUserInput,
          afterVideoPlayback: this.afterVideoPlayback,
          showHelpButton: this.showHelpButton,
          warning: _state.DeckUI.warning,
          hint: this.hint,
          sentenceHint: this.sentenceHint,
          hintParts: this.hintParts,
          shouldFloatHints: this.shouldFloatHints,
          onHelpButtonClicked: this.onHelpButtonClicked,
          icons: this.icons,
          onTextInputChange: this.onTextInputChange,
          message: this.message,
          setShowHelp: this.setShowHelp,
          hideOnboardingPopups: this.hideOnboardingPopups,
          onHideArrowBox: this.hideOnboardingPopups,
          diff: this.diff,
          correctAnswer: this.correctAnswer,
          correctAnswerWithDiff: this.correctAnswerWithDiff,
          wrongAnswerWithDiff: this.wrongAnswerWithDiff,
          showExpandedTarget: this.showExpandedTarget
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "message", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "message"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showHelpButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showHelpButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "numSections", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "numSections"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sectionHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sectionHeight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "vocabCardIncorrect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "vocabCardIncorrect"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "arrowBoxes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "arrowBoxes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "possibleArrowBoxes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "possibleArrowBoxes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentArrowBox", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "currentArrowBox"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "answerFeedback", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "answerFeedback"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showUserInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showUserInput"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasSentenceHint", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasSentenceHint"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sentenceHintParts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sentenceHintParts"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hintParts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hintParts"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "letterHint", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "letterHint"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hint", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hint"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sentenceHint", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sentenceHint"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctAnswer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctAnswer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctAnswerWithDiff", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctAnswerWithDiff"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wrongAnswerWithDiff", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wrongAnswerWithDiff"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showExpandedTarget", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showExpandedTarget"), _class2.prototype), _class2)) || _class;
};
WordTranslateCardWrapper.displayName = 'WordTranslateCardWrapper';
var _default = exports["default"] = WordTranslateCardWrapper;